import { Property } from "./interfaces";

export const fechaNacimientoRecienNacido: Property = {
  title: "Fecha de Nacimiento",
  type: "string",
  format: "local-date-time",
};
